import * as React from 'react';
import { Mutation } from 'react-apollo';
import { Box } from '@origin-digital/style-guide';

import { Fields } from './Fields';
import { CREATE_ENQUIRY } from '../../../../mutations';
import { initialValues, validation } from './formConfig';

import ThankYou from '../ThankYou';
import { Formik, FormikProps, FormikValues } from 'formik';
import { RequestServiceInitialValues } from '../../SolarContact.types';

import { RequestServiceProps, RequestServiceState } from './RequestService.types';

// @ts-ignore
import general from './meta/general.json';
import logger from '../../../../logging';
import analytics from '../../../../analytics';

class RequestService extends React.Component<RequestServiceProps, RequestServiceState> {
  constructor(props: RequestServiceProps) {
    super(props);

    this.state = {
      key: 1,
      successfulSubmit: undefined,
      currentValues: {},
      productType: 'REPAIRS',
      asyncFetching: false,
      postcode: '3000',
      asyncSuccess: undefined,
      showManualAddress: false
    };

    this.onResponse = this.onResponse.bind(this);
    this.onError = this.onError.bind(this);
    this.onReset = this.onReset.bind(this);
    this.setProductType = this.setProductType.bind(this);
    this.setAsyncFetching = this.setAsyncFetching.bind(this);
    this.setDisqualification = this.setDisqualification.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.enterAddressManually = this.enterAddressManually.bind(this);
  }
  //@ts-ignore
  onResponse(res): void {
    const { onGraphError } = this.props;

    analytics.submitSuccessful(this.state.currentValues);
    logger.info(res);
    this.setState({
      successfulSubmit: true
    });
    onGraphError(false);
  }

  //@ts-ignore
  onError(apolloError): void {
    logger.error('GraphQL Error', apolloError);
    const { onGraphError } = this.props;
    const { currentValues } = this.state;
    const { graphQLErrors } = apolloError;

    // check for specific error codes to render specific error messages
    if (graphQLErrors && graphQLErrors.length > 0) {
      const firstError = graphQLErrors[0];
      if (firstError && firstError.extensions) {
        const { extensions } = firstError;
        if (
          extensions.code === 'USER_INPUT_ERROR' &&
          extensions.invalidField === 'postcode' &&
          extensions.invalidReason === 'STATE_MISMATCH'
        ) {
          const error = {
            postcode: currentValues.postcode,
            state: currentValues.state
          };
          return onGraphError(
            true,
            `Oops, postcode ${error.postcode} does not exist in ${error.state}. Please try again.`
          );
        }
      }
    }

    // unknown error happened render generic error
    return onGraphError(true);
  }

  onReset(): void {
    const { key } = this.state;
    let newKey = key;

    this.setState({
      key: (newKey += 1),
      successfulSubmit: undefined
    });
  }

  getValues(values: FormikValues): RequestServiceInitialValues {
    return {
      enquiryType: values.enquiryType,
      comment: values.comment,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
      address: {
        unit: values.unit,
        streetNumber: values.streetNumber,
        streetName: values.streetName,
        suburb: values.suburb,
        state: values.state,
        postcode: values.postcode
      },
      allowMarketingCommunications: !values.allowMarketingCommunications
    };
  }

  setProductType(value: string): void {
    this.setState({
      productType: value
    });
  }

  setAsyncFetching(asyncFetching: boolean): void {
    this.setState({
      asyncFetching
    });
  }

  setDisqualification(value: boolean): void {
    this.setState({
      asyncSuccess: value
    });
  }

  enterAddressManually = (): void => {
    this.setState({
      showManualAddress: true
    });
  };

  onFieldChange(fieldName: string, value: string): void {
    const { currentValues } = this.state;

    this.setState({
      currentValues: {
        ...currentValues,
        [fieldName]: value
      }
    });
  }

  componentDidMount() {
    analytics.pageLoad('form');
  }

  render(): JSX.Element | null {
    const { graphError, graphMessage, onGraphError } = this.props;
    const { successfulSubmit, productType, asyncFetching, asyncSuccess, showManualAddress } = this.state;

    if (successfulSubmit) {
      return (
        <Box>
          <ThankYou metaData={general} />
        </Box>
      );
    }

    return (
      <Mutation mutation={CREATE_ENQUIRY} onCompleted={this.onResponse} onError={this.onError}>
        {(createEnquiry, { loading }) => {
          return (
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={(values: FormikValues) => {
                this.setState({
                  currentValues: {
                    enquiryType: values.enquiryType,
                    postcode: values.postcode,
                    state: values.state,
                    allowMarketingCommunications: values.allowMarketingCommunications
                  }
                });
                createEnquiry({
                  variables: {
                    input: this.getValues(values)
                  }
                });
              }}
              render={({ errors, isValid }: FormikProps<FormikValues>) => {
                return (
                  <Fields
                    metaData={general}
                    // @ts-ignore
                    errors={errors}
                    isValid={isValid}
                    isSubmitting={loading}
                    productType={productType}
                    setProductType={this.setProductType}
                    asyncFetching={asyncFetching}
                    setAsyncFetching={this.setAsyncFetching}
                    setDisqualification={this.setDisqualification}
                    onGraphError={onGraphError}
                    graphMessage={graphMessage}
                    graphError={graphError}
                    onFieldChange={this.onFieldChange}
                    enterAddressManually={this.enterAddressManually}
                    showManualAddress={showManualAddress}
                    asyncSuccess={asyncSuccess}
                  />
                );
              }}
            />
          );
        }}
      </Mutation>
    );
  }
}

export { RequestService as default };
